import ColumnAvatar from '../components/Redesing/column-avatar';
import PersonIcon from '@mui/icons-material/Person';
import { Stack, Typography } from '@mui/material';
import { SeverityPill } from '../components/Redesing/severity-pill';
import { getLocaleDateString } from '../utils';
import IconButtonMenu from '../components/Redesing/icon-button-menu';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
export const organizationAdminsColumns = (setSelectedAdmin, setConfirm, onEdit) => {
  return [
    {
      id: 'full_name',
      label: 'Admin',
      searchable: true,
      showToolTip: true,
      maxWidth: '350px',
      notSortable: true,
      exportFormat: (cell) => cell?.admin_name || '',
      format: (cell) => {
        return (
          <ColumnAvatar
            avatar={<PersonIcon />}
            firstRow={
              <Typography color="text.pramary" variant="body1">
                {cell?.admin_name || ''}
              </Typography>
            }
            secondRow={
              <Typography color="text.secondary" variant="body2">
                <SeverityPill color={'info'}>{cell?.admin_email || ''}</SeverityPill>
              </Typography>
            }
          />
        );
      },
    },
    {
      id: 'joined_at',
      label: 'Joined',
      exportFormat: (cell) => cell?.joined_at || '',
      format: (cell) => getLocaleDateString(cell?.joined_at || ''),
    },
    {
      id: 'actions',
      label: `Actions`,
      notSortable: true,
      align: 'center',
      format: (row) => {
        const arrayBtns = [
          {
            label: '',
            startIcon: <EditIcon />,
            onClick: (e) => {
              e.stopPropagation();
              onEdit(row);
            },
          },
          {
            label: '',
            startIcon: <DeleteIcon />,
            onClick: (e) => {
              e.stopPropagation();
              setSelectedAdmin(row);
              setConfirm(true);
            },
          },
        ];

        return (
          <Stack justifyContent={'center'} alignItems={'center'}>
            <IconButtonMenu buttons={arrayBtns} />
          </Stack>
        );
      },
    },
  ];
};
